
export default function RoundStatus({
    mode,
    phase = "ready", // ready | reading | buzzable | answering | pass_review | feedback | complete
    round,
    totalRounds,
    className = "",
}) {
    const config = getPhaseConfig(phase);

    const hasValidProgress =
        typeof round === "number" &&
        typeof totalRounds === "number" &&
        totalRounds > 0;

    const progressPercent =
        phase === "complete"
            ? 100
            : hasValidProgress
                ? Math.min(100, Math.max(0, (round / totalRounds) * 100))
                : 0;

    return (
        <section
            className={`round-status round-status--${phase} ${className}`.trim()}
            aria-live="polite"
        >
            <div className="round-status__top">
                <div className="round-status__phase-wrap">
                    <span className="round-status__label">
                        {mode !== "review" ? config.label : ""}
                    </span>
                </div>

                {phase !== "complete" && hasValidProgress ? (
                    <div className="round-status__round">
                        Clue {round} / {totalRounds}
                    </div>
                ) : null}
            </div>

            {mode !== "review" && phase === "reading" && (
                <div className="round-status__message">
                    {config.message}
                </div>
            )}

            <div
                className="round-status__bar"
                role="progressbar"
                aria-label="Clue progress"
                aria-valuemin={0}
                aria-valuemax={totalRounds ?? 0}
                aria-valuenow={hasValidProgress ? round : 0}
                aria-valuetext={
                    hasValidProgress
                        ? `Clue ${round} of ${totalRounds}`
                        : "Progress unavailable"
                }
            >
                <div
                    className="round-status__bar-fill"
                    style={{
                        width: `${progressPercent}%`,
                    }}
                />
            </div>
        </section>
    );
}

function getPhaseConfig(phase) {
  switch (phase) {
    case "reading":
      return {
        label: "Reading",
        message: "Wait until the clue finishes",
      };

    case "buzzable":
      return {
        label: "Buzz now",
        message: "",
      };

    case "answering":
      return {
        label: "Answer",
        message: "",
      };

    case "pass_review":
      return {
        label: "Review",
        message: "",
      };

    case "ready":
    case "feedback":
    case "complete":
    default:
      return {
        label: "",
        message: "",
      };
  }
}